// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { sync } from 'vuex-router-sync'
import Shortkey from 'vue-shortkey'
import VueSticky from 'vue-sticky'
import VueMdcTextField from 'vue-mdc-adapter/components/textfield'
import VeeValidate from 'vee-validate'
import validation from './lib/validation'
import {
  Alert,
  Pagination,
  Select,
  Option,
  DatePicker,
  TimeSelect,
  TimePicker,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  InputNumber,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Switch,
  Upload,
  Progress,
  Form,
  FormItem,
  Table,
  TableColumn,
  Tabs,
  TabPane
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import FlagIcon from 'vue-flag-icon'
import VueClipboard from 'vue-clipboard2'
import VueApexCharts from 'vue-apexcharts'
import VueMq from 'vue-mq'

import searchbar from '@/components/searchbar'
import sortable from '@/components/sortable'
import inputError from '@/components/input-error'
import inputText from '@/components/input-text'
import mainfooter from '@/components/mainfooter'
import mainnav from '@/components/mainnav'
import slider from '@/components/slider'
import MixinCommon from '@/mixins/common'
import MixinDates from '@/mixins/dates'
import Api from './api'
import Checkout from './checkout'
import Dialogues from './dialogues'
import App from './App'
import router from './router'
import { store } from '@/store'
import i18n from './config/i18n'
import VueScrollTo from 'vue-scrollto'

import '@/stats'
// import initNotifications from '@/notifications'

import './assets/sass/element-variables.scss'
import './assets/sass/main.scss'

import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

import pack from '../package.json'

Sentry.init({
  release: pack.version,
  dsn: 'https://c9e3d3e366754416848a025a0b72668a@sentry.uscreen.net/2',
  integrations: process.env.NODE_ENV === 'production' ? [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ] : []
})

const GRAPHCMS_API = 'https://getnext.to/content/'
const httpLink = new HttpLink({
  uri: GRAPHCMS_API
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

sync(store, router) // done. Returns an unsync callback fn

Vue.use(Shortkey, { prevent: ['input', 'textarea'] })
Vue.use(VueMdcTextField)

// configure language for el-ui
locale.use(lang)

Vue.use(Alert)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(InputNumber)

Vue.use(Button)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(VueClipboard)
Vue.use(VueScrollTo)

Vue.use(FlagIcon)

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 768,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.component('searchbar', searchbar)
Vue.component('input-error', inputError)
Vue.component('input-text', inputText)
Vue.component('sortable', sortable)
Vue.component('mainfooter', mainfooter)
Vue.component('mainnav', mainnav)
Vue.component('slider', slider)
Vue.component('apexchart', VueApexCharts)

Vue.directive('sticky', VueSticky)

Vue.mixin(MixinCommon)
Vue.mixin(MixinDates)

Vue.use(Api, {
  baseURL: process.env.api_url,
  store
})

Vue.use(Checkout)

Vue.use(Dialogues)

Vue.use(VeeValidate, {
  i18n,
  i18nRootKey: 'validation'
})
validation(VeeValidate)

Vue.prototype.$eventBus = new Vue()
// initNotifications(Vue.prototype.$eventBus)

store.dispatch('reLogin').then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    provide: apolloProvider.provide(),
    router,
    i18n,
    template: '<App/>',
    components: { App },
    store
  })
})



// WEBPACK FOOTER //
// ./src/main.js